import { IAppState } from '../../redux';
import { HOMEOWNERS_NEW_ADD_FORM } from '../../constants/experiments';

export const selectHomeownerNewAddFormEnabled = (state: IAppState) => {
  const { abExperiments } = state;

  return abExperiments[HOMEOWNERS_NEW_ADD_FORM] === 'enabled';
};
